module.exports = __webpack_public_path__ + "static/img/logo4.1dcba48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo4.png
// module id = pqs/
// module chunks = 1